import React from "react";
import useAllPlayers from "../../hooks/queryResults/useAllPlayers";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useWaiversPlayers from "../../hooks/queryResults/useWaiversPlayers";
import Loading from "../ui/Loading";
import PlayersTable from "./PlayersTable";

export default function LeagueWaiversPlayers() {
  const { waiversPlayersData, waiversPlayersQuery } = useWaiversPlayers();
  const { playersData, playersQuery } = useAllPlayers();

  const isLoading = useIsLoading(
    waiversPlayersData,
    waiversPlayersQuery,
    playersData,
    playersQuery
  );
  if (isLoading) return <Loading />;

  const waiversPlayers = Object.keys(waiversPlayersData.waivers.players).map(
    (playerId) => playersData.players[playerId]
  );

  return (
    <div>
      <h3>Players currently on waivers</h3>
      <PlayersTable
        players={waiversPlayers}
        playersToShow={waiversPlayers}
        pageSize={50}
      />
    </div>
  );
}
